import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeServicesRow } from '../components/home/HomeServicesRow';
export function Home() {
  return <main id="home" className="w-full bg-cream" data-id="element-452" data-mp="2ndjtg7ro5swi">
      <HomeHero data-id="element-453" data-mp="2s7o1yvgl28zp" />
      <HomeServicesRow data-id="element-454" data-mp="2s74ru0x6cow8" />
    </main>;
}